module.exports = __webpack_public_path__ + "img/qp_logo_white.c5c77d3d.png";